import { useState, useCallback } from 'react';

var defaultFocusKeys = ['Tab'];
var useFocused = function useFocused(props) {
  var onBlur = props.onBlur,
      onKeyUp = props.onKeyUp,
      _props$focusKeys = props.focusKeys,
      focusKeys = _props$focusKeys === void 0 ? defaultFocusKeys : _props$focusKeys;

  var _useState = useState(false),
      focused = _useState[0],
      setFocused = _useState[1];

  var handleBlur = useCallback(function (e) {
    setFocused(false);

    if (typeof onBlur === 'function') {
      onBlur(e);
    }
  }, [onBlur]);
  var handleKeyUp = useCallback(function (e) {
    if (e && e.key && focusKeys.includes(e.key)) {
      setFocused(true);
    }

    if (typeof onKeyUp === 'function') {
      onKeyUp(e);
    }
  }, [onKeyUp]);
  return {
    handleBlur: handleBlur,
    handleKeyUp: handleKeyUp,
    focused: focused
  };
};

export { useFocused };
